import React from 'react'
import BaseComponent from '../../../common/base';
import { Card, Button, Form, Col } from 'react-bootstrap';
import QuestionnairePartialCard from '../../partials/card';

export class StepPreparationDone extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = Object.assign(
            this.state,
            {
                consent: false,
                age: "",
            }
        )
    }

    onSubmit(e) {
        this.props.dbSet(`age`, this.state.age);
        this.props.nextStep();
    }

    render() {
        return (
            <>
                <QuestionnairePartialCard
                    title={this.t('questionnaire.preparation.consent.title')}
                    body={
                        <>
                            <div className={`border px-3 py-3 animated rounded shadow-sm my-4`}>
                                <Card.Text>
                                    {this.t(`questionnaire.preparation.consent.text`)}
                                    {` `}
                                    <a target="_blank" rel="noopener nofollow noreferrer" href={`${process.env.PUBLIC_URL}/doc/consentpjatk_pl.pdf`}>pl</a>
                                    {` / `}
                                    <a target="_blank" rel="noopener nofollow noreferrer" href={`${process.env.PUBLIC_URL}/doc/consentpjatk_en.pdf`}>en</a>
                                    {` / `}
                                    <a target="_blank" rel="noopener nofollow noreferrer" href={`${process.env.PUBLIC_URL}/doc/consentpjatk_uk.pdf`}>uk</a>
                                    {` / `}
                                    <a target="_blank" rel="noopener nofollow noreferrer" href={`${process.env.PUBLIC_URL}/doc/consentpjatk_ru.pdf`}>ru</a>
                                </Card.Text>

                                <hr />

                                <Form.Group key={`consent`}>
                                    <Form.Check
                                        custom
                                        type={'checkbox'}
                                        name={`consent`}
                                        id={`consent`}
                                        label={this.t(`questionnaire.preparation.consent.consent`)}
                                        checked={this.state.consent}
                                        onChange={(e) => { this.setState({ consent: !this.state.consent }) }}
                                    />
                                </Form.Group>

                                <hr />

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label column lg={5}>
                                            {this.t(`questionnaire.preparation.consent.age`)}
                                        </Form.Label>
                                        <Col>
                                            <Form.Control
                                                required
                                                type="number"
                                                min={18}
                                                max={128}
                                                placeholder={this.t(`questionnaire.common.typeValue`)}
                                                value={this.state.age}
                                                onChange={(e) => this.onChange('age', e)}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                            </div>

                            <Button
                                type="button"
                                onClick={(e) => this.onSubmit(e)}
                                variant="primary"
                                disabled={!this.state.consent || !this.state.age || (parseInt(this.state.age, 10) < 18)}
                            >
                                {this.t('questionnaire.preparation.consent.start')}
                            </Button>
                        </>
                    }
                />
            </>
        )
    }

}

export default StepPreparationDone;